import { PaymentOnlineOrigin } from '@alpha/payments-dtos';

import { FormikPaymentType } from '../../CreatePaymentDrawer/formData';

export const initialValues: FormikPaymentType = {
  emailAddresses: [],
  paymentOrigin: PaymentOnlineOrigin.STANDALONE,
  date: null,
};

export default initialValues;
